/* App — FAQ accordion (one open at a time; clicking the open one closes it). */
(function () {
  function init(root) {
    if (!root || root._apFaq) return;
    root._apFaq = true;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var b = item.querySelector('button');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    items.forEach(function (item) {
      var b = item.querySelector('button');
      if (!b) return;
      b.addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        items.forEach(function (o) { setOpen(o, o === item ? open : false); });
        if (window.ScrollTrigger) setTimeout(function () { window.ScrollTrigger.refresh(); }, 480);
      });
    });
  }
  function all(scope) { (scope || document).querySelectorAll('[data-section-type="app-faq"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();
